import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { HiylloTokyoThemeDark } from "./hiyllo-tokyo-theme";
// @ts-ignore
export function getThemeContext() {
    // @ts-ignore
    if (window._hiylloUXThemeCtx == null) {
        // @ts-ignore
        window._hiylloUXThemeCtx = React.createContext(HiylloTokyoThemeDark);
    }
    // @ts-ignore
    return window._hiylloUXThemeCtx;
}
export const useTheme = () => {
    const ctx = getThemeContext();
    return React.useContext(ctx);
};
export const ThemeProvider = React.memo(function ThemeProvider(props) {
    const ThemeContext = getThemeContext();
    return (_jsx(ThemeContext.Provider, { value: props.theme, children: props.children }));
});
